/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { ExploreContentViewActivityWorkoutVideoPlayer } from './ExploreContentViewActivityWorkoutVideoPlayer';
import { ExploreContentViewActivityWorkoutContent } from './ExploreContentViewActivityWorkoutContent';
import { ExploreContentViewHostCard } from '../ExploreContentViewHostCard';
import { ActivityWorkoutEntry } from '../../../Model/Explore/ActivityWorkoutEntry';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const PageContainer = styled.div`
  min-height: 100vh;
  background: #fafafa;
`;

const VideoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 32px 0;

  @media (max-width: 768px) {
    padding: 16px 16px 0;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 32px 64px;
  animation: ${fadeIn} 0.6s ease-out;

  @media (max-width: 768px) {
    padding: 24px 16px 48px;
  }
`;

const ContentCard = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-start;
  width: 100%;
  background: white;
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
    gap: 24px;
  }
`;

const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const SideContent = styled.div`
  flex-shrink: 0;
  width: 280px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export type ExploreContentViewActivityWorkoutProps = {
  entry: ActivityWorkoutEntry;
};

export const ExploreContentViewActivityWorkout: React.FC<ExploreContentViewActivityWorkoutProps> = observer(
  ({ entry }) => {
    return (
      <PageContainer>
        <VideoSection>
          <ExploreContentViewActivityWorkoutVideoPlayer entry={entry} />
        </VideoSection>

        <ContentContainer>
          <ContentCard>
            <MainContent>
              <ExploreContentViewActivityWorkoutContent entry={entry} />
            </MainContent>
            <SideContent>
              <ExploreContentViewHostCard host={entry.instructor} />
            </SideContent>
          </ContentCard>
        </ContentContainer>
      </PageContainer>
    );
  },
);
